<template>
  <div>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col>
          <b-row class="mb-1">
            <b-col
              col="6"
              md="3"
            >
              <b-form-checkbox
                id="reversed"
                v-model="filters['is_reverse_order']"
                :value="true"
                :unchecked-value="false"
              >
                Reversed Orders Only
              </b-form-checkbox>
            </b-col>
            <b-col
              col="6"
              md="3"
            >
              <b-form-checkbox
                id="remarks"
                v-model="filters['order_remark']"
                :value="true"
                :unchecked-value="false"
              >
                Orders With Remarks
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Status"
                label-for="status"
              >
                <StatusFilterModal
                  v-model="selectedStatusFilters"
                  modal-id="status-filter-modal-all-orders"
                  :status-options="statusOptions"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Customer Name"
                label-for="customer_name"
              >
                <b-form-input
                  id="customer_name"
                  v-model="filters['customer_name']"
                  placeholder="Search"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Origin Warehouse"
                label-for="customer_name"
              >
                <v-select
                  v-model="filters['origin_warehouse']"
                  :options="warehouseOptions"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Warehouse"
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Destination Warehouse"
                label-for="customer_name"
              >
                <v-select
                  v-model="selectedDestinationWarehouseFilters"
                  :options="warehouseOptions"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Warehouse"
                  multiple
                  deselect-from-dropdown
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Origin City"
                label-for="origin"
              >
                <v-select
                  id="origin"
                  v-model="filters['origin_city_id']"
                  :options="cityOptions"
                  :reduce="option => option.id"
                  label="name"
                  autocomplete="nope"
                  placeholder="Select Origin City"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Destination City"
                label-for="destination"
              >
                <v-select
                  id="destination"
                  v-model="filters['destination_city_id']"
                  :options="cityOptions"
                  :reduce="option => option.id"
                  label="name"
                  autocomplete="nope"
                  placeholder="Select Destination City"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Customer Mobile Number"
                label-for="customer_name"
              >
                <b-form-input
                  id="customer_name"
                  v-model="filters['customer_phone']"
                  placeholder="Search"
                  type="number"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Weight"
                label-for="weight"
              >
                <cleave
                  id="weight"
                  v-model="filters['orders.weight']"
                  class="form-control"
                  :raw="false"
                  :options="options.delimiter"
                  placeholder="0000 to 0000"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Order Date"
                label-for="order_date"
              >
                <div class="position-relative">
                  <AdvancedDateFilter
                    :date-value="filters['orders.created_at']"
                    :opens="'right'"
                    @update="updateDateRange('orders.created_at', $event)"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Merchant"
                label-for="merchant"
              >
                <v-select
                  v-model="selectedMerchantFilters"
                  :options="merchantOptions"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Merchant"
                  multiple
                  deselect-from-dropdown
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Merchant Business"
                label-for="merchant business"
              >
                <v-select
                  v-model="selectedBusinessFilters"
                  :options="merchantBusinessOptions"
                  :reduce="option => option.id"
                  label="display_name"
                  placeholder="Select Merchant Business"
                  multiple
                  deselect-from-dropdown
                >
                  <template v-slot:option="option">
                    <div class="d-flex flex-column">
                      <span class="font-weight-bold">{{ option.business_name }}</span>
                      <small class="text-muted">{{ option.merchant_name }}</small>
                    </div>
                  </template>
                  <template v-slot:selected-option="option">
                    <span class="text-truncate flex-grow-1 mr-1">
                      <span class="font-weight-bold">{{ option.business_name }}</span>
                      <span class="text-muted ml-1">({{ option.merchant_name }})</span>
                    </span>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Rider"
                label-for="customer_name"
              >
                <v-select
                  v-model="filters['rider']"
                  :options="riderOptions"
                  :reduce="option => option.id"
                  label="first_name"
                  placeholder="Select Rider"
                >
                  <template v-slot:option="option">
                    {{ option.reference_id }} | {{ option.first_name }} {{ option.last_name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Status Changed Date"
                label-for="customer_name"
              >
                <div class="position-relative">
                  <AdvancedDateFilter
                    :date-value="filters['status_date']"
                    :opens="'right'"
                    @update="updateDateRange('status_date', $event)"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="COD"
                label-for="cod"
              >
                <b-form-input
                  id="cod"
                  v-model="filters['orders.cod']"
                  placeholder="0000 to 0000"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Collected COD"
                label-for="collected_cod"
              >
                <b-form-input
                  id="collected_cod"
                  v-model="filters['orders.collected_cod']"
                  placeholder="0000 to 0000"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-can="'view-delivery-charge'"
              cols="6"
              md="3"
            >
              <b-form-group
                label="Delivery Charge"
                label-for="delivery_charge"
              >
                <b-form-input
                  id="delivery_charge"
                  v-model="filters['orders.delivery_charge']"
                  placeholder="0000 to 0000"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Temporary Warehouse"
                label-for="delivery_charge"
              >
                <v-select
                  v-model="filters['orders.temporary_warehouse_id']"
                  :options="warehouseOptions"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Warehouse"
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              v-can="'create-walking-orders'"
              cols="6"
              md="3"
            >
              <b-form-group
                label="Walking Customer"
                label-for="senderName"
              >
                <v-select
                  v-model="filters['walking_customer_id']"
                  :options="walkingCustomers"
                  :reduce="option => option.id"
                  label="name"
                  autocomplete="nope"
                  placeholder="Select Walking Customer"
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Order Flags"
                label-for="delivery_charge"
              >
                <v-select
                  v-model="selectedFlagFilters"
                  :options="flagOptions"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Flags"
                  multiple
                  deselect-from-dropdown
                >
                  <template
                    v-slot:option="option"
                    class="text-truncate"
                  >
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="General Search"
                label-for="general_search"
              >
                <b-form-input
                  id="general_search"
                  v-model="filters['search']"
                  placeholder="Search"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="6"
              md="3"
            >
              <b-form-group
                label="Delivery Attempts"
                label-for="delivery_attempts"
              >
                <b-form-input
                  id="delivery_attempts"
                  v-model="filters['delivery_attempts']"
                  placeholder="00 to 00"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Apply and Clear Filters -->
          <b-row class="mt-1">
            <b-col>
              <filter-buttons
                ref="filterButtons"
                :filter-data="filters"
                :apply-filters="applyFilters"
                :clear-filters="clearFilters"
                :show-saved-filters="true"
                screen="All Orders"
                @save-filters="onSaveFilterClick"
                @apply-saved-filter="applySavedFilter"
                @edit-saved-filter="onEditSavedFilter"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </FilterCard>
    <div>
      <b-row>
        <summary-card
          title="All ORDERS"
          :sum="orderOptions.all_orders.sum"
          :count="orderOptions.all_orders.count"
          :border-variant="selection === 'allOrders'? '' :'primary'"
          :bg-variant="selection === 'allOrders'? 'var(--primary)' :''"
          :text-variant="selection === 'allOrders'? 'white' :'#5c5b61'"
          @click.native="onSummaryCardClick('','allOrders')"
        />
        <summary-card
          :title="`TO BE ${statusOptions.filter(option => option.key === 'key_13')[0].name}`"
          :sum="orderOptions.to_be_delivered.sum"
          :count="orderOptions.to_be_delivered.count"
          :border-variant="selection === 'to_be_delivered'? '' :'primary'"
          :bg-variant="selection === 'to_be_delivered'? 'var(--primary)' :''"
          :text-variant="selection === 'to_be_delivered'? 'white' :'#5c5b61'"
          @click.native="onSummaryCardClick('key_6,key_12','to_be_delivered')"
        />
        <summary-card
          :title="`TO BE RETURNED`"
          :sum="orderOptions.to_be_returned.sum"
          :count="orderOptions.to_be_returned.count"
          :border-variant="selection === 'to_be_returned'? '' :'primary'"
          :bg-variant="selection === 'to_be_returned'? 'var(--primary)' :''"
          :text-variant="selection === 'to_be_returned'? 'white' :'#5c5b61'"
          @click.native="onSummaryCardClick('key_18,key_19','to_be_returned')"
        />
        <summary-card
          :title="statusOptions.filter(option => option.key === 'key_13')[0].name"
          :sum="orderOptions.delivered.sum"
          :count="orderOptions.delivered.count"
          :border-variant="selection === 'delivered'? '' :'primary'"
          :bg-variant="selection === 'delivered'? 'var(--primary)' :''"
          :text-variant="selection === 'delivered'? 'white' :'#5c5b61'"
          @click.native="onSummaryCardClick('key_7,key_13,key_14','delivered')"
        />
        <summary-card
          title="All RETURN"
          :sum="orderOptions.returned.sum"
          :count="orderOptions.returned.count"
          :border-variant="selection === 'returned'? '' :'primary'"
          :bg-variant="selection === 'returned'? 'var(--primary)' :''"
          :text-variant="selection === 'returned'? 'white' :'#5c5b61'"
          @click.native="onSummaryCardClick('key_20,key_21','returned')"
        />
      </b-row>
      <b-card
        no-body
      >
        <div>
          <div
            class="m-2"
          >
            <!-- input -->
            <b-row
              cols="12"
              class="mb-0"
            >
              <b-col
                md="3"
              >
                <b-form-group
                  label="Waybill Number"
                  label-for="waybill_number"
                >
                  <b-form-input
                    id="waybill_number"
                    v-model="filters['waybill_number']"
                    placeholder="Search"
                    autocomplete="nope"
                    @paste="handlePaste"
                    @keyup.enter="getOrderList"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="10"
                sm="10"
                md="2"
                lg="3"
              >
                <b-form-group
                  label="Order Number"
                  label-for="order_no"
                >
                  <b-form-input
                    id="order_number"
                    v-model="filters['order_no']"
                    placeholder="Search"
                    autocomplete="nope"
                    @paste="handlePaste"
                    @keyup.enter="getOrderList"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="2"
                md="1"
                class="mt-2 mt-md-0 d-flex justify-content-end justify-content-md-start"
              >
                <WaybillSearch
                  class="waybill-search"
                  :waybill-number="filters['waybill_number']"
                  :order-number="filters['order_no']"
                  @search="getOrderList"
                />
              </b-col>
              <b-col
                class="d-flex justify-content-end align-items-center mb-md-0"
              >
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-tooltip.hover.v-primary="'Access your report directly here'"
                  class="custom-button-color mr-1"
                  size="sm"
                  @click="onClickReport()"
                >
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1maWxlLXRleHQtaWNvbiBsdWNpZGUtZmlsZS10ZXh0Ij48cGF0aCBkPSJNNiAyMmEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmg4YTIuNCAyLjQgMCAwIDEgMS43MDQuNzA2bDMuNTg4IDMuNTg4QTIuNCAyLjQgMCAwIDEgMjAgOHYxMmEyIDIgMCAwIDEtMiAyeiIvPjxwYXRoIGQ9Ik0xNCAydjVhMSAxIDAgMCAwIDEgMWg1Ii8+PHBhdGggZD0iTTEwIDlIOCIvPjxwYXRoIGQ9Ik0xNiAxM0g4Ii8+PHBhdGggZD0iTTE2IDE3SDgiLz48L3N2Zz4="
                  >
                </b-button>
                <b-tooltip
                  target="print_button"
                  triggers="hover"
                  variant="primary"
                >
                  Print Waybills
                </b-tooltip>
                <div
                  id="print_button"
                  class="d-flex align-items-center"
                >
                  <b-dropdown
                    id="printDropdown"
                    split-class="custom-button-color-blur unable-pointer"
                    toggle-class="custom-button-color"
                    size="sm"
                    role="menu"
                    split
                    class="mr-mobile-half mr-md-1"
                    :disabled="selectedWaybillArray.length === 0"
                  >
                    <template #button-content>
                      <img
                        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1xci1jb2RlIj48cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSI1IiB4PSIzIiB5PSIzIiByeD0iMSIvPjxyZWN0IHdpZHRoPSI1IiBoZWlnaHQ9IjUiIHg9IjE2IiB5PSIzIiByeD0iMSIvPjxyZWN0IHdpZHRoPSI1IiBoZWlnaHQ9IjUiIHg9IjMiIHk9IjE2IiByeD0iMSIvPjxwYXRoIGQ9Ik0yMSAxNmgtM2EyIDIgMCAwIDAtMiAydjMiLz48cGF0aCBkPSJNMjEgMjF2LjAxIi8+PHBhdGggZD0iTTEyIDd2M2EyIDIgMCAwIDEtMiAySDciLz48cGF0aCBkPSJNMyAxMmguMDEiLz48cGF0aCBkPSJNMTIgM2guMDEiLz48cGF0aCBkPSJNMTIgMTZ2LjAxIi8+PHBhdGggZD0iTTE2IDEyaDEiLz48cGF0aCBkPSJNMjEgMTJ2LjAxIi8+PHBhdGggZD0iTTEyIDIxdi0xIi8+PC9zdmc+"
                      >
                    </template>
                    <b-dropdown-item
                      v-for="(option, index) in layoutDropdownOptions"
                      :key="index"
                      @click="onClickPrintDispatch(option.id)"
                    >
                      {{ option.name }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
                <ReportTableButtons
                  :items="rows"
                  :json_fieldz="json_fields"
                  :name="`AllOrders - Page ${page}.xls`"
                  :bulkname="`AllOrders.xls`"
                  :fetch="getOrderListQueue"
                  :table-fields="tableFields"
                  :table-data="tableData"
                  :title="`All Orders -${ meta.from } to ${ meta.to } of ${ meta.total } entries`"
                  :show_custom_popup="true"
                  :queue-enable="true"
                  :queue-permission="`download-all-orders`"
                  @refresh="onClickRefresh"
                />
              </b-col>
            </b-row>
            <b-row class="d-sm-flex align-items-start">
              <b-col class="pt-1 pt-md-0">
                <div class="font-weight-bolder">
                  {{ `${selectedWaybillArray.length} record${selectedWaybillArray.length === 1 ? '':'s'}` }} selected
                </div>
              </b-col>
              <b-col
                :cols="{ sm: 12, md: 12 }"
                class="d-block d-flex justify-content-end align-items-center mb-md-0 actionButtons pr-1"
              >
                <div class="d-flex flex-row">
                  <b-tooltip
                    target="ChangeOriginPickupWarehouse"
                    triggers="hover"
                    variant="primary"
                  >
                    Change Origin/Pickup Warehouse
                  </b-tooltip>
                  <div id="ChangeOriginPickupWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_2') && isBulkUpdate('key_4')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="primary"
                      class="ml-1 mt-1 mt-md-0 btn-relief-primary"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onChangeOriginPickupWarehouse()"
                    >
                      <mdicon
                        name="HomeCircleOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="AssignToPickupRider"
                    triggers="hover"
                    variant="info"
                  >
                    Assign To Pickup Rider
                  </b-tooltip>
                  <div id="AssignToPickupRider">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_2') || selectedStatusFilters.includes('key_4')) && isBulkUpdate('key_5')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="info"
                      class="ml-1 mt-1 mt-md-0 btn-relief-info outline"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onAssignToPickupRider()"
                    >
                      <mdicon
                        name="BicycleBasket"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="CancelClick"
                    triggers="hover"
                    variant="danger"
                  >
                    Cancel
                  </b-tooltip>
                  <div id="CancelClick">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_2') && isBulkUpdate('key_3')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onCancelClick()"
                    >
                      <mdicon
                        name="DeleteCircleOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="PickupFromMerchant"
                    triggers="hover"
                    variant="info"
                  >
                    Pick Up From Merchant
                  </b-tooltip>
                  <div id="PickupFromMerchant">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_5') && isBulkUpdate('key_6')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="info"
                      class="ml-1 mt-1 mt-md-0 btn-relief-info"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onPickupFromMerchantClick()"
                    >
                      <mdicon
                        name="Dolly"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="PickupDeliver"
                    triggers="hover"
                    variant="success"
                  >
                    Delivered By Pickup Rider
                  </b-tooltip>
                  <div id="PickupDeliver">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_6') && isBulkUpdate('key_7')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="success"
                      class="ml-1 mt-1 mt-md-0 btn-relief-success"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onPickupDeliverClick()"
                    >
                      <mdicon
                        name="Bike"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="Dispatch"
                    triggers="hover"
                    variant="info"
                  >
                    Dispatched To Origin Warehouse
                  </b-tooltip>
                  <div id="Dispatch">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_6') && isBulkUpdate('key_8')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="info"
                      class="ml-1 mt-1 mt-md-0 btn-relief-info"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onDispatchClick()"
                    >
                      <mdicon
                        name="HomeOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="ReceiveAtOriginWarehouse"
                    triggers="hover"
                    variant="primary"
                  >
                    Received At Origin Warehouse
                  </b-tooltip>
                  <div id="ReceiveAtOriginWarehouse">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_2') || selectedStatusFilters.includes('key_4') || selectedStatusFilters.includes('key_8')) && isBulkUpdate('key_9')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="primary"
                      class="ml-1 mt-1 mt-md-0 btn-relief-primary"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReceiveAtOriginWarehouse()"
                    >
                      <mdicon
                        name="HomeMapMarker"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="DispatchedToDestinationWarehouse"
                    triggers="hover"
                    variant="primary"
                  >
                    Dispatched To Destination Warehouse
                  </b-tooltip>
                  <div id="DispatchedToDestinationWarehouse">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_9') || selectedStatusFilters.includes('key_29')) && isBulkUpdate('key_10')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="primary"
                      class="ml-1 mt-1 mt-md-0 btn-relief-primary"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickDispatchedToDestinationWarehouse()"
                    >
                      <mdicon
                        name="HomeExportOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="ReceivedAtDestinationWarehouse"
                    triggers="hover"
                    variant="info"
                  >
                    Received At Destination Warehouse
                  </b-tooltip>
                  <div id="ReceivedAtDestinationWarehouse">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_8') || selectedStatusFilters.includes('key_10')) && isBulkUpdate('key_11')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="info"
                      class="ml-1 mt-1 mt-md-0 btn-relief-info"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReceivedAtDestinationWarehouse()"
                    >
                      <mdicon
                        name="HomeGroup"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="AssignedToDestinationRider"
                    triggers="hover"
                    variant="info"
                  >
                    Assigned To Destination Rider
                  </b-tooltip>
                  <div id="AssignedToDestinationRider">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_9') || selectedStatusFilters.includes('key_11') || selectedStatusFilters.includes('key_16')) && isBulkUpdate('key_12')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="info"
                      class="ml-1 mt-1 mt-md-0 btn-relief-info"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickAssignedToDestinationRider()"
                    >
                      <mdicon
                        name="BikeFast"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="Deliver"
                    triggers="hover"
                    variant="success"
                  >
                    Delivered
                  </b-tooltip>
                  <div id="Deliver">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_12') && isBulkUpdate('key_13')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="success"
                      class="ml-1 mt-1 mt-md-0 btn-relief-success"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickDeliver()"
                    >
                      <mdicon
                        name="BriefcaseCheckOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="Return"
                    triggers="hover"
                    variant="warning"
                  >
                    Returned To Destination Warehouse
                  </b-tooltip>
                  <div id="Return">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_12') && isBulkUpdate('key_15')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="warning"
                      class="ml-1 mt-1 mt-md-0 btn-relief-warning"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReturn()"
                    >
                      <mdicon
                        name="HomeGroup"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="bulkFlag"
                    triggers="hover"
                    variant="primary"
                  >
                    Bulk Flag
                  </b-tooltip>
                  <div id="bulkFlag">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_17') || selectedStatusFilters.includes('key_18') || selectedStatusFilters.includes('key_19')) && isStaffEnabled"
                      v-can="'edit-orders'"
                      variant="primary"
                      class="ml-1 mt-1 mt-md-0 btn-relief-warning"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickBulkFlagUpdate()"
                    >
                      <feather-icon
                        icon="FlagIcon"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="Reschedule"
                    triggers="hover"
                    variant="warning"
                  >
                    Rescheduled
                  </b-tooltip>
                  <div id="Reschedule">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_15') || selectedStatusFilters.includes('key_17')) && isBulkUpdate('key_16')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="warning"
                      class="ml-1 mt-1 mt-md-0 btn-relief-warning"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReschedule()"
                    >
                      <mdicon
                        name="Update"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="DeliveryFailed"
                    triggers="hover"
                    variant="danger"
                  >
                    Failed To Deliver
                  </b-tooltip>
                  <div id="DeliveryFailed">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_15') && isBulkUpdate('key_17')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickDeliveryFailed()"
                    >
                      <mdicon
                        name="HomeAlertOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="VerifyFailedToDeliver"
                    triggers="hover"
                    variant="success"
                  >
                    Verify Failed To Deliver
                  </b-tooltip>
                  <div id="VerifyFailedToDeliver">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_17') && isBulkUpdate('key_36')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="success"
                      class="ml-1 mt-1 mt-md-0 btn-relief-success"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickVerifyFailedToDeliver()"
                    >
                      <mdicon
                        name="CheckCircleOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="ReturnedToSortingWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Returned To Sorting Warehouse
                  </b-tooltip>
                  <div id="ReturnedToSortingWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_36') && isBulkUpdate('key_18')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReturnedToSortingWarehouse()"
                    >
                      <mdicon
                        name="TruckDelivery"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="FailedReceiveToOriginWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Received At Sorting Warehouse [Delivery Failed]
                  </b-tooltip>
                  <div id="FailedReceiveToOriginWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_18') && isBulkUpdate('key_19')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickFailedReceiveToOriginWarehouse()"
                    >
                      <mdicon
                        name="AlertDecagramOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="returnToMerchant"
                    triggers="hover"
                    variant="danger"
                  >
                    Returned to Merchant
                  </b-tooltip>
                  <div id="returnToMerchant">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_19')|| selectedStatusFilters.includes('key_36')) && isBulkUpdate('key_20')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReturnedToMerchant()"
                    >
                      <mdicon
                        name="AccountAlertOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div
                  v-can="'edit-orders'"
                >
                  <b-tooltip
                    target="receive_failed_order_wc"
                    triggers="hover"
                    variant="warning"
                  >
                    Receive Failed Order Walking Customer
                  </b-tooltip>
                  <div id="receive_failed_order_wc">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_20') && isBulkUpdate('key_22')"
                      v-can:all="['create-walking-orders', 'bulk-update-operation']"
                      variant="warning"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReceiveFailedOrderWalkingCustomer()"
                    >
                      <mdicon
                        name="AccountAlertOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <!-- <div>
                  <b-tooltip
                    target="InvalidDestination"
                    triggers="hover"
                    variant="danger"
                  >
                    Invalid Destination
                  </b-tooltip>
                  <div id="InvalidDestination">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_11')|| selectedStatusFilters.includes('key_12')|| selectedStatusFilters.includes('key_15')) && isBulkUpdate('key_26')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickInvalidDestination()"
                    >
                      <mdicon
                        name="HomeAlert"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div> -->
                <div>
                  <b-tooltip
                    target="ReturnedToSortingWarehouseInvalidDestination"
                    triggers="hover"
                    variant="danger"
                  >
                    Returned to Sorting Warehouse [Invalid Destination]
                  </b-tooltip>
                  <div id="ReturnedToSortingWarehouseInvalidDestination">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_26') && isBulkUpdate('key_27')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReturnedToSortingWarehouseInvalidDestination()"
                    >
                      <mdicon
                        name="TruckDelivery"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <!-- <div>
                  <b-tooltip
                    target="ReceiveToOriginWarehouseInvalidDestination"
                    triggers="hover"
                    variant="danger"
                  >
                    Received to Origin Warehouse [Invalid Destination]
                  </b-tooltip>
                  <div id="ReceiveToOriginWarehouseInvalidDestination">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_27') && isBulkUpdate('key_28')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReceivedToOriginWarehouseInvalidDestination()"
                    >
                      <mdicon
                        name="HomeImportOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div> -->
                <!-- <div>
                  <b-tooltip
                    target="DifferentDestination"
                    triggers="hover"
                    variant="primary"
                  >
                    Change Destination
                  </b-tooltip>
                  <div id="DifferentDestination">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_28') && isBulkUpdate('key_29')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="primary"
                      class="ml-1 mt-1 mt-md-0 btn-relief-primary"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickDifferentDestination()"
                    >
                      <mdicon
                        name="SwapHorizontal"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div> -->
                <div>
                  <b-tooltip
                    target="returnOrderdispatchedToOriginWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Return Order - Dispatched To Origin Warehouse
                  </b-tooltip>
                  <div id="returnOrderdispatchedToOriginWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_20') && isBulkUpdate('key_23')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReturnOrderDispatchedToOriginWarehouse()"
                    >
                      <mdicon
                        name="HomeExportOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="returnOrderReceivedAtOriginWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Return Order - Received At Origin Warehouse
                  </b-tooltip>
                  <div id="returnOrderReceivedAtOriginWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_23') && isBulkUpdate('key_24')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReturnOrderReceivedAtOriginWarehouse()"
                    >
                      <mdicon
                        name="truckOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="assignToReturnRider"
                    triggers="hover"
                    variant="danger"
                  >
                    Assigned To Return Rider
                  </b-tooltip>
                  <div id="assignToReturnRider">
                    <b-button
                      v-if="(selectedStatusFilters.includes('key_24') || selectedStatusFilters.includes('key_33')) && isBulkUpdate('key_25')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickAssignToReturnRider()"
                    >
                      <mdicon
                        name="BikeFast"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="receivedAtOriginWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Received At Origin Warehouse (Failed To Return)
                  </b-tooltip>
                  <div id="receivedAtOriginWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_31') && isBulkUpdate('key_32')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReceivedAtOriginWarehouse()"
                    >
                      <mdicon
                        name="HomeImportOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="rescheduleReturn"
                    triggers="hover"
                    variant="danger"
                  >
                    Return Order - Reschedule
                  </b-tooltip>
                  <div id="rescheduleReturn">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_32') && isBulkUpdate('key_33')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickRescheduleReturn()"
                    >
                      <mdicon
                        name="CalendarBlankOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="HandedOverToMerchant"
                    triggers="hover"
                    variant="danger"
                  >
                    Handed Over To Merchant
                  </b-tooltip>
                  <div id="HandedOverToMerchant">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_25') && isBulkUpdate('key_30')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickHandedOverToMerchant()"
                    >
                      <mdicon
                        name="AccountAlertOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="dispatchedToSortingWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Dispatched To Sorting Warehouse
                  </b-tooltip>
                  <div id="dispatchedToSortingWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_9') && isBulkUpdate('key_34')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickDispatchedToSortingWarehouse()"
                    >
                      <mdicon
                        name="AccountAlertOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="receivedToSortingWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Received At Sorting Warehouse
                  </b-tooltip>
                  <div id="receivedToSortingWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_2') || selectedStatusFilters.includes('key_34') || isBulkUpdate('key_35')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReceivedAtSortingWarehouse()"
                    >
                      <mdicon
                        name="AccountAlertOutline"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="returnToPickupWarehouse"
                    triggers="hover"
                    variant="danger"
                  >
                    Return To Origin Warehouse (failed To Return)
                  </b-tooltip>
                  <div id="returnToPickupWarehouse">
                    <b-button
                      v-if="selectedStatusFilters.includes('key_25') && isBulkUpdate('key_31')"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickReturnToPickupWarehouse()"
                    >
                      <mdicon
                        name="TruckDelivery"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="customStatusButton"
                    triggers="hover"
                    :variant="customStatusObject ? customStatusObject.color : 'primary'"
                  >
                    {{ customStatusButtonInfo }}
                  </b-tooltip>
                  <div id="customStatusButton">
                    <b-button
                      v-if="shouldShowCustomStatusButton"
                      v-can:all="['edit-orders', 'bulk-update-operation']"
                      :variant="customStatusObject ? customStatusObject.color : 'primary'"
                      class="ml-1 mt-1 mt-md-0 btn-relief-primary"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;' : ''"
                      :disabled="selectedWaybillArray.length === 0"
                      @click="onClickCustomStatus()"
                    >
                      <feather-icon
                        :icon="customStatusObject ? customStatusObject.icon : 'CogOutline'"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
                <div>
                  <b-tooltip
                    target="reverse_button"
                    triggers="hover"
                    variant="danger"
                  >
                    Reverse Orders
                  </b-tooltip>
                  <div id="reverse_button">
                    <b-button
                      v-can="'add-reversal'"
                      :disabled="selectedWaybillArray.length === 0"
                      variant="danger"
                      class="ml-1 mt-1 mt-md-0 btn-relief-danger bg-darken-2"
                      size="sm"
                      :style="selectedWaybillArray.length === 0 ? 'pointer-events:none;':''"
                      @click="onClickReverse()"
                    >
                      <mdicon
                        name="UndoVariant"
                        size="15"
                      />
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- table -->
          <b-overlay
            id="overlay-background"
            variant="light"
            opacity="0.30"
            blur="10px"
            rounded="sm"
          >
            <b-table
              id="all-order-table"
              :key="filters.rider"
              v-sortable="filters.rider ? sortableOptions : null"
              responsive
              striped
              hover
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              show-empty
              class="hide-vertical-scroll"
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowUpIcon'
                      : 'ArrowDownIcon'"
                    size="14"
                  />
                </div>
              </template>
              <template #head(id)>
                <div class="d-flex align-items-start">
                  <div>
                    <b-form-checkbox
                      id="selectAllCheckbox"
                      v-model="selectAllCheckbox"
                      name="selectAllCheckbox"
                      @change="onClickSelectAllCheckbox()"
                    />
                  </div>
                </div>
              </template>
              <template #cell(id)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="font-weight-bolder">
                      <b-form-checkbox
                        v-model="selectedWaybillArray"
                        :value="data.item.waybill_number"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(waybill_number)="data">
                <div
                  class="d-flex align-items-center"
                >
                  <b-avatar
                    :text="avatarText(data.item.customer_name)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      :class="{'font-weight-bolder ml-1 text-danger': data.item.temporary_warehouse_id !=null ,'font-weight-bolder ml-1 text-primary':data.item.temporary_warehouse_id ===null}"
                      @click="onClickViewOrder(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.name)="data">
                <div class="d-flex align-items-start">
                  <span
                    v-if="data.item.merchant && data.item.merchant.is_key_client"
                    v-b-tooltip.hover.v-primary="'Key Client'"
                    class="mr-50"
                  >
                    <mdicon
                      name="Crown"
                      size="18"
                      class="key-client-crown"
                    />
                  </span>
                  <div>
                    <div class="">
                      {{ __orderMerchantName(data.item) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ data.item.customer_name }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.customer_address }}
                    </div>
                    <div class="font-small-2">
                      {{ data.value }}
                    </div>
                    <div class="font-small-2">
                      <div><b>Primary number: </b>{{ data.item.customer_phone }}</div>
                    </div>
                    <div
                      v-if="data.item.customer_secondary_phone !== null"
                      class="font-small-2"
                    >
                      <div><b>Second number: </b>{{ data.item.customer_secondary_phone }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(origin_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.origin_city.name }}
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(destination_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.destination_city.name }}
                    <!--                    </b-badge>-->
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #head(delivery_possibility)>
                <div class="text-left d-flex align-items-center">

                  <div class="sortable-header">
                    <span class="header-text"> AI DSR (Beta)</span>
                    <feather-icon
                      v-b-tooltip.hover.html="'<div style=&quot;text-align: left; white-space: normal;&quot;>AI-Powered Delivery Success Rate is the ability to predict the risk of customer returns using artificial intelligence. <a href=&quot;https://www.canva.com/design/DAGOAKRJAMQ/zQlhkuq7HgtIR7Qay5fjIA/view?utm_content=DAGOAKRJAMQ&utm_campaign=designshare&utm_medium=link&utm_source=editor&quot; target=&quot;_blank&quot;>More Details</a><br><br>0% - 30%: High chance of return<br>30% - 65%: Average chance of delivery<br>65% - 100%: High chance of delivery<br><br>This is a Beta Version.</div>'"
                      icon="InfoIcon"
                      size="16"
                      class="ml-1"
                    />
                  </div>
                </div>
              </template>
              <template #cell(delivery_possibility)="data">
                <div
                  v-if="data.item.delivery_possibility"
                  :style="{ width:'150px'}"
                >
                  {{ data.item.delivery_possibility }}%
                  <b-progress
                    :value="data.item.delivery_possibility"
                    :variant="getProgressVariant(data.item.delivery_possibility)"
                    :class="getProgressBarClass(data.item.delivery_possibility)"
                    max="100"
                  />
                </div>
                <div
                  v-if="!data.item.delivery_possibility"
                  class="spinner-border"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>

                </div>
              </template>
              <template #cell(finance)="data">
                <div :class="`width-150 d-flex justify-content-center align-items-start ${data.item.merchant.merchant_setting ? 'flex-column' : 'flex-column-reverse'}`">
                  <div v-if="data.item.merchant.merchant_setting">
                    <b>COD&nbsp;:</b>&nbsp;&nbsp;{{ __numberWithCommas(data.item.cod, true) || '---' }}
                  </div>
                  <!-- <div v-if="!data.item.merchant.merchant_setting">
                    <b>Balance&nbsp;:</b>&nbsp;&nbsp;{{ __numberWithCommas(data.item.delivery_charge - data.item.collected_cod, true ) || '---' }}
                  </div> -->
                  <div style="height:8px;" />
                  <div><b>{{ data.item.merchant.merchant_setting ? 'Collected' : 'Advance' }}&nbsp;:</b>&nbsp;&nbsp;{{ __numberWithCommas(data.item.collected_cod, true) || '---' }}</div>
                  <div
                    v-if="store.getters.permissions.filter(permission => permission === 'view-delivery-charge').length > 0"
                  >
                    <div style="height:8px;" />
                    <div><b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ __numberWithCommas(data.item.delivery_charge, true) || '---' }}</div>
                  </div>
                </div>
              </template>
              <template #cell(weight)="data">
                {{ (data.value).toLocaleString() }}
              </template>
              <template #cell(delivery_attempts)="data">
                <div class="d-flex align-items-center justify-content-center">
                  <b-avatar
                    :text="data.item.delivery_attempts.toString()"
                    size="32"
                    :variant="data.item.delivery_attempts <= 5 ? 'light-success' : 'light-danger'"
                  />
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(rider_name)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ `${data.item.rider ? data.item.rider.first_name : 'N/A'} ${data.item.rider && data.item.rider.last_name ? data.item.rider.last_name : ''}` }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider && data.item.rider.email ? data.item.rider.email : '' }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider && data.item.rider.reference_id ? data.item.rider.reference_id : '' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(latest_status_updated_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>

              <!-- ... Flag Componant ... -->
              <template #cell(order_flags)="data">
                <div class="d-flex align-items-center">
                  <FlagDisplay :flags="data.item.order_flags" />
                </div>
              </template>

              <template #cell(remark)="data">
                <div>
                  <b-badge
                    :variant="data.value > 0 ? 'light-info':'light-danger'"
                    @click="onClickMakeRemark(data.item.id)"
                  >
                    {{ data.value === 0 ? 'None' : `${data.value} remark${data.value === 1 ? '' : 's'}` }}
                  </b-badge>
                </div>
              </template>

              <template #cell(order_current_status.key)="data">
                <div>
                  <order-status-badge :status-key="data.value" />
                </div>
                <div
                  v-if="data.item.is_reversed_order === true"
                  class="mt-1 d-flex"
                >
                  <div>
                    <b-tooltip
                      :target="(data.item.id + data.item.reversal.current_status.key)"
                      triggers="hover"
                      :style="{
                        backgroundColor: data.item.reversal.current_status.color,
                      }"
                    >
                      {{ data.item.reversal.current_status.name }}
                    </b-tooltip>
                    <b-avatar
                      :id="(data.item.id + data.item.reversal.current_status.key)"
                      size="20"
                      :style="{
                        backgroundColor: getLightBackground(data.item.reversal.current_status.color),
                        color: data.item.reversal.current_status.color,
                      }"
                    >
                      <feather-icon
                        :icon="data.item.reversal.current_status.icon"
                        size="10"
                        class="text-body align-middle"
                      />
                    </b-avatar>
                  </div>
                &nbsp;&nbsp;
                  <div>
                    <feather-icon
                      icon="ChevronsLeftIcon"
                      class="text-body align-middle"
                    />
                  </div>
                &nbsp;&nbsp;
                  <div>
                    <b-tooltip
                      :target="(data.item.id + data.item.reversal.previous_status.key)"
                      triggers="hover"
                      :style="{
                        backgroundColor: data.item.reversal.previous_status.color,
                      }"
                    >
                      {{ data.item.reversal.previous_status.name }}
                    </b-tooltip>
                    <b-avatar
                      :id="(data.item.id + data.item.reversal.previous_status.key)"
                      size="20"
                      :style="{
                        backgroundColor: getLightBackground(data.item.reversal.previous_status.color),
                        color: data.item.reversal.previous_status.color,
                      }"
                    >
                      <feather-icon
                        :icon="data.item.reversal.previous_status.icon"
                        size="10"
                        class="text-body align-middle"
                      />
                    </b-avatar>
                  </div>
                </div>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  :class="rows.length !== 1 ? 'dropdown-no-scroll':''"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="12"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    v-can="'show-orders'"
                    @click="onClickViewOrder(data.item.id)"
                  >
                    <feather-icon icon="EyeIcon" />
                    View
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canEditOrder(data.item.order_current_status.key)"
                    v-can="'edit-orders'"
                    @click="onClickEditOrder(data.item.id)"
                  >
                    <feather-icon icon="EditIcon" />
                    Edit
                  </b-dropdown-item>
                  <!-- Weight History temporarily commented out for release -->
                  <!-- <b-dropdown-item
                    v-if="!canEditOrder(data.item.order_current_status.key)"
                    @click="onClickViewWeightHistory(data.item.id)"
                  >
                    <feather-icon icon="ClockIcon" />
                    Weight History
                  </b-dropdown-item> -->
                  <b-dropdown-item
                    v-if="!(data.item.order_current_status.key === 'key_1')"
                    v-can="'add-reversal'"
                    @click="onClickReverse(data.item.id)"
                  >
                    <feather-icon icon="CornerDownLeftIcon" />
                    Reverse Order
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-can="'order-remark-show'"
                    @click="onClickMakeRemark(data.item.id)"
                  >
                    <feather-icon icon="BookmarkIcon" />
                    Make Remark
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-can="'order-flag-view'"
                    @click="onClickFlagDetail(data.item.waybill_number, data.item.order_current_status.key, data.item.id)"
                  >
                    <feather-icon icon="FlagIcon" />
                    Flags
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="data.item.rider_signature"
                    :href="`${bucketUrl}${data.item.rider_signature}`"
                    target="_blank"
                  >
                    <feather-icon icon="Edit2Icon" />
                    View Receiver's Signature
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="data.item.feedback_url != null"
                    v-can="'view-feedback-link'"
                    @click="onClickViewFeedBack(data.item.id, data.item.feedback_url)"
                  >
                    <feather-icon icon="StarIcon" />
                    View FeedBack
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row
                cols="12"
              >
                <b-col
                  class="d-flex align-items-center justify-content-sm-start"
                  md="3"
                >
                  <label class="width-75">Per page</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block width-125"
                  />
                </b-col>
                <!-- Pagination -->
                <b-col
                  class="d-flex align-items-center justify-content-sm-end"
                  md="9"
                >
                  <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                  <b-pagination
                    v-model="page"
                    :per-page="perPage"
                    :total-rows="(meta.total)? meta.total : 0"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-overlay>
        </div>
      </b-card>
    </div>
    <make-remark ref="add_make_remark" />
    <view-feedback ref="view_feedback" />
    <make-future-request ref="add_future_request" />
    <flag-details ref="flag_detail" />
    <view-order-modal ref="viewOrderModal" />
    <reverse-order-modal
      ref="reverseOrderModal"
      :selected_waybill_array="selectedWaybillArray"
    />
    <bulk-flag-update
      ref="BulkFlagUpdate"
      :selected_waybill_array="selectedWaybillArray"
    />
    <update-order-details ref="editOrderModal" />
    <!-- Weight History modal temporarily commented out for release -->
    <!-- <view-weight-history ref="viewWeightHistoryModal" /> -->
    <bulk-action-modal
      ref="bulkActionModal"
      :form_structure="formStructure"
      :status_key="status_key"
      :selected_waybill_array="selectedWaybillArray"
      :rows="rows"
      :order_settings="orderSettings"
    />
    <save-filter-modal
      ref="saveFilterModal"
      @save="saveFilter"
    />
    <edit-saved-filter-modal
      ref="editSavedFilterModal"
      :options="{
        status: statusOptions,
        warehouses: warehouseOptions,
        merchants: merchantOptions,
        riders: riderOptions,
        flags: flagOptions,
        cities: cityOptions,
        walkingCustomers: walkingCustomers,
        businesses: merchantBusinessOptions
      }"
      @fetch-businesses="fetchMerchantBusinesses"
      @update="updateSavedFilter"
    />
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BPagination,
  BRow,
  BOverlay,
  BBadge,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  VBTooltip,
  BTooltip,
  BProgress,
} from 'bootstrap-vue'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import { bucketUrl } from '@/constants/config'
import Cleave from 'vue-cleave-component'
import MakeRemark from '@/components/AllOrders/Remark/MakeRemark.vue'
import ViewFeedback from '@/components/AllOrders/FeedBack/ViewFeedBack.vue'
import FlagDetails from '@/components/AllOrders/FlagDetails.vue'
import MakeFutureRequest from '@/components/AllOrders/MakeFutureRequest.vue'
import UpdateOrderDetails from '@/components/AllOrders/UpdateOrderDetails.vue'
// import ViewWeightHistory from '@/components/AllOrders/ViewWeightHistory.vue' // TEMPORARILY COMMENTED OUT FOR RELEASE
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import sortable from '@/libs/sortable'
import store from '@/store/index'
import ViewOrderModal from '@/components/AllOrders/ViewOrderModal.vue'
import ReverseOrderModal from '@/components/AllOrders/ReverseOrderModal.vue'
import BulkActionModal from '@/components/status-flow/bulk-actions/BulkActionModal.vue'
import BulkFlagUpdate from '@/components/AllOrders/BulkFlagUpdate.vue'
import FlagDisplay from '@/components/AllOrders/OrderFlags/FlagDisplay.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import SummaryCard from '@core/components/summary-card/SummaryCard.vue'
import KeyFour from '@/components/status-flow/KeyFour.vue'
import KeyFive from '@/components/status-flow/KeyFive.vue'
import KeySeven from '@/components/status-flow/KeySeven.vue'
import KeyNine from '@/components/status-flow/KeyNine.vue'
import KeyTen from '@/components/status-flow/KeyTen.vue'
import KeyTwelve from '@/components/status-flow/KeyTwelve.vue'
import KeyFourteen from '@/components/status-flow/KeyFourteen.vue'
import KeyFifteen from '@/components/status-flow/KeyFifteen.vue'
import KeySixteen from '@/components/status-flow/KeySixteen.vue'
import KeySeventeen from '@/components/status-flow/KeySeventeen.vue'
import KeyThirtySix from '@/components/status-flow/KeyThirtySix.vue'
import KeyTwentySix from '@/components/status-flow/KeyTwentySix.vue'
import KeyTwentyEight from '@/components/status-flow/KeyTwentyEight.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import SaveFilterModal from '@/components/Filter/SaveFilterModal.vue'
import EditSavedFilterModal from '@/components/Filter/EditSavedFilterModal.vue'
import 'vue2-timeago/dist/vue2-timeago.css'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import KeyThirtyThree from '@/components/status-flow/KeyThirtyThree.vue'
import KeyThirtyOne from '@/components/status-flow/KeyThirtyOne.vue'
import KeyThirty from '@/components/status-flow/KeyThirty.vue'
import KeyTwentyFive from '@/components/status-flow/KeyTwentyFive.vue'
import KeyReturnCommon from '@/components/status-flow/KeyReturnCommon.vue'
import KeyCustom from '@/components/status-flow/KeyCustom.vue'
import WaybillSearch from '@/components/status-flow/WaybillSearch/WaybillSearch.vue'
import StatusMixin from '@core/mixins/status'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import StatusFilterModal from '@/components/Filter/StatusFilterModal.vue'

const ResourceRepository = RepositoryFactory.get('resource')
const orderRepository = RepositoryFactory.get('order')
const merchantRepository = RepositoryFactory.get('merchant')
const riderRepository = RepositoryFactory.get('rider')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')
const WalkingCustomerRepository = RepositoryFactory.get('walkingCustomer')
const LayoutRepository = RepositoryFactory.get('layout')
const MerchantRepository = RepositoryFactory.get('merchant')
const AiSettingRepository = RepositoryFactory.get('aiSetting')
const flagRepository = RepositoryFactory.get('flag')
const savedFilterRepository = RepositoryFactory.get('savedFilter')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
    sortable,
  },
  components: {
    BTooltip,
    BAvatar,
    BButton,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
    BBadge,
    vSelect,
    OrderStatusBadge,
    BDropdown,
    BDropdownItem,
    MakeRemark,
    ViewFeedback,
    MakeFutureRequest,
    FlagDetails,
    Cleave,
    ViewOrderModal,
    SummaryCard,
    UpdateOrderDetails,
    // ViewWeightHistory, // TEMPORARILY COMMENTED OUT FOR RELEASE
    BulkActionModal,
    ReverseOrderModal,
    FeatherIcon,
    BProgress,
    FilterButtons,
    BulkFlagUpdate,
    FlagDisplay,
    AdvancedDateFilter,
    WaybillSearch,
    FilterCard,
    SaveFilterModal,
    EditSavedFilterModal,
    StatusFilterModal,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, StatusMixin, tableMixin],
  data() {
    return {
      layoutDropdownOptions: {},
      longString: true,
      refreshedDate: new Date(),
      isCollapsed: false,
      store,
      isApplyingSavedFilter: false,
      filters: {
        'orders.created_at': {
          startDate: null,
          endDate: null,
        },
        status_date: {
          startDate: null,
          endDate: null,
        },
      },
      selectedStatusFilters: [],
      statusOptions: [],
      warehouseOptions: [],
      flagOptions: [],
      selectedFlagFilters: [],
      selectedDestinationWarehouseFilters: [],
      cityOptions: [],
      riderOptions: [],
      merchantOptions: [],
      selectedMerchantFilters: [],
      walkingCustomers: [],
      selectedBusinessFilters: [],
      merchantBusinessOptions: [],
      merchant_business_id: [],
      options: {
        delimiter: {
          delimiter: ' to ',
          blocks: [4, 4],
          uppercase: true,
        },
      },
      // Filters End
      avatarText,
      bucketUrl,
      total: 0,
      meta: {},
      loading: false,
      dataLoading: false,
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500],
      totalRows: 1,
      page: 1,
      selectedKey: '',
      orderSettings: null,
      rows: [],
      allData: [],
      isAsc: true, // true = up, false = down

      selectedWaybillArray: [],
      json_fields: {
        'Waybill Number': 'waybill_number',
        'Order Number': 'order_no',
        Merchant: {
          field: 'merchant.name',
          callback: value => `"${value}"`,
        },
        'Merchant Business': {
          field: 'merchant_business.business_name',
          callback: value => (value ? `"${value}"` : 'N/A'),
        },
        'Origin City': {
          field: 'origin_city.name',
          callback: value => `"${value}"`,
        },
        'Origin Warehouse': {
          field: 'origin_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Destination City': {
          field: 'destination_city.name',
          callback: value => `"${value}"`,
        },
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value?.replace(/"/g, '""') || ''}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value.replace(/"/g, '""')}"`,
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: 'cod',
        'Collected Cod': 'collected_cod',
        // 'Delivery Charge': 'delivery_charge',
        'Net Weight': 'weight',
        'Delivery Attempts': 'delivery_attempts',
        Rider: {
          callback: value => `"${value.rider !== null ? `${value.rider.first_name}` : 'N/A'} ${value.rider !== null && value.rider.last_name !== null ? `${value.rider.last_name}` : ''}"`,
        },
        'Rider Employee Id': {
          callback: value => `"${value.rider !== null ? `${value.rider.reference_id}` : 'N/A'}"`,
        },
        Remark: {
          field: 'first_merchant_remark.remark',
          callback: value => `"${value.replace(/"/g, '""')}"`,
        },
        'Status Changed Date': {
          field: 'latest_status_updated_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Created At': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        Flag: {
          field: 'order_flags',
          callback: value => {
            const flagNames = value.map(flag => flag.name).join(', ')
            return `"${flagNames}"`
          },
        },
        Description: {
          field: 'description',
          callback: value => `"${value?.replace(/"/g, '""') || ''}"`,
        },
        Status: 'order_current_status.name',
      },
      status_key: '',
      formStructure: [],
      sortingOrder: null,
      sortableOptions: {
        chosenClass: 'is-selected',
        animation: 150,
        onEnd: event => {
          if (this.filters.rider) {
            this.updateRiderSortIndex(event.newIndex)
          }
        },
        onStart: event => {
          this.sortingOrder = this.rows[event.oldIndex]
        },
      },
      selection: 'allOrders',
      orderOptions: {
        all_orders: {},
        to_be_delivered: {},
        to_be_returned: {},
        delivered: {},
        returned: {},
      },
      format: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      },
      tableFields: [
        'Waybill Number',
        'Merchant',
        'Origin City',
        'Origin Warehouse',
        'Destination City',
        'Destination Warehouse',
        'Customer Name',
        'Delivery Probability',
        'Customer Email',
        'Customer Address',
        'Customer Phone',
        { title: 'COD', styles: { halign: 'right' } },
        { title: 'Collected Cod', styles: { halign: 'right' } },
        { title: 'Delivery Charge', styles: { halign: 'right' } },
        { title: 'Weight', styles: { halign: 'right' } },
        'Created At',
        'Description',
        'Status',
      ],
      selectAllCheckbox: false,
      aiModuleEnabled: false,
      aiEnabled: false,
      isStaffEnabled: false,
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    tableData() {
      return this.rows.map(item => [item.waybill_number, item.merchant.name, item.origin_city.name, item.origin_warehouse.name, item.destination_city.name, item.destination_warehouse.name, item.customer_name, item.customer_email, item.customer_address, [item.customer_phone, item.customer_secondary_phone], (item.cod).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), item.collected_cod ? (item.collected_cod).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-', (item.delivery_charge).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), item.weight, item.created_at ? new Date(item.created_at).toLocaleDateString('en-GB', this.format) : '-', item.description, item.order_current_status.name])
    },
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
    isAiFeatureEnabled() {
      return this.aiModuleEnabled && this.aiEnabled
    },
    shouldShowCustomStatusButton() {
      // Check if selected status filters include a key that has after_statuses array containing a status starting with 'cus_' and bulk update enabled
      return this.selectedStatusFilters.some(selectedKey => {
        const status = this.statusOptions.find(
          option => option.key === selectedKey,
        )
        if (
          status
          && status.after_statuses
          && Array.isArray(status.after_statuses)
          && status.is_bulk_update === true
        ) {
          // Check if any custom status in after_statuses is active
          return status.after_statuses
            .filter(afterStatus => afterStatus.startsWith('cus_'))
            .some(customStatusKey => {
              const customStatus = this.statusOptions.find(
                option => option.key === customStatusKey,
              )
              return customStatus && customStatus.is_active === true
            })
        }
        return false
      })
    },
    customStatusButtonInfo() {
      // Get the custom status info for the tooltip
      const customStatus = this.customStatusObject
      return customStatus ? customStatus.name : null
    },
    customStatusObject() {
      // Get the full custom status object
      const matchingStatus = this.statusOptions.find(
        status => this.selectedStatusFilters.includes(status.key)
          && status.after_statuses
          && Array.isArray(status.after_statuses)
          && status.after_statuses.some(afterStatus => afterStatus.startsWith('cus_'))
          && status.is_bulk_update === true,
      )

      if (matchingStatus && matchingStatus.after_statuses) {
        // Return the first custom status found in the array
        const customStatusKey = matchingStatus.after_statuses.find(afterStatus => afterStatus.startsWith('cus_'))
        const customStatus = this.statusOptions.find(status => status.key === customStatusKey)
        return customStatus || null
      }
      return null
    },
    fields() {
      const baseFields = [
        {
          key: 'id',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'waybill_number',
          label: 'WayBill Number',
          sortable: true,
        },
        {
          key: 'remark', label: 'Remarks', sortable: false, thClass: 'text-center', tdClass: 'text-center',
        },
        {
          key: 'merchant.name',
          label: 'Merchant',
          sortable: true,
        },
        {
          key: 'origin_warehouse',
          label: 'Origin',
          sortable: true,
          thClass: ' text-left',
          tdClass: ' text-left',
        },
        {
          key: 'destination_warehouse',
          label: 'Destination',
          sortable: true,
          thClass: ' text-left',
          tdClass: ' text-left',
        },
        {
          key: 'customer_email',
          label: 'Customer',
          sortable: true,
          thClass: ' text-left',
          tdClass: ' text-left',
        },
        {
          key: 'finance',
          label: 'Finance',
          sortable: false,
        },
        {
          key: 'weight',
          label: 'Net Weight',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'delivery_attempts',
          label: 'Delivery Attempts',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'rider_name',
          label: 'Rider',
          sortable: true,
        },
        {
          key: 'latest_status_updated_at',
          label: 'Status Changed Date',
          sortable: false,
          thClass: ' text-left',
          tdClass: ' text-left',
        },
        { key: 'order_flags', label: 'Flags', sortable: false },
        {
          key: 'order_current_status.key',
          label: 'Status',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]

      // Add the AI DSR (Beta) field if the feature is enabled
      if (this.isAiFeatureEnabled) {
        baseFields.splice(6, 0, {
          key: 'delivery_possibility',
          label: 'AI DSR (Beta)',
          sortable: true,
          thClass: ' text-left',
          tdClass: ' text-center',
        })
      }

      return baseFields
    },
  },
  watch: {
    page() {
      this.getOrderList()
    },
    perPage() {
      this.getOrderList()
    },
    selectedStatusFilters: {
      async handler(val) {
        let keyList = ''
        val.forEach(key => {
          keyList += `${key},`
        })
        this.filters = {
          ...this.filters,
          status: keyList,
        }
      },
      deep: true,
    },
    selectedFlagFilters: {
      async handler(val) {
        let keyList = ''
        val.forEach(key => {
          keyList += `${key},`
        })
        this.filters = {
          ...this.filters,
          order_flag: keyList,
        }
      },
      deep: true,
    },
    selectedBusinessFilters: {
      async handler(val) {
        let keyList = ''
        val.forEach(key => {
          keyList += `${key},`
        })
        this.filters = {
          ...this.filters,
          merchant_business_id: keyList,
        }
      },
      deep: true,
    },
    selectedDestinationWarehouseFilters: {
      async handler(val) {
        let keyList = ''
        val.forEach(key => {
          keyList += `${key},`
        })
        this.filters = {
          ...this.filters,
          destination_warehouse: keyList,
        }
      },
      deep: true,
    },
    selectedMerchantFilters: {
      async handler(val) {
        let keyList = ''
        val.forEach(key => {
          keyList += `${key},`
        })
        this.filters = {
          ...this.filters,
          merchant_id: keyList,
        }
        // Update merchant business list when merchants change
        this.getMerchantBusinessList()
      },
      deep: true,
    },
    // eslint-disable-next-line func-names
    'filters.waybill_number': function (newValue) {
      if (!newValue) { // Check if waybill_number is cleared
        this.getOrderList()
      }
    },
    // eslint-disable-next-line func-names
    'filters.order_no': function (newValue) {
      if (!newValue) { // Check if order_no is cleared
        this.getOrderList()
      }
    },
  },
  async mounted() {
    this.totalRows = this.rows.length
    this.setMonthFilter()
    this.getOrderList()
    this.readOrderStatuses()
    this.getWarehouseList()
    this.readOrderSetting()
    this.fetchModules()
    this.readAiSetting()
    this.getOrderSummary()
    await this.getCityList()
    await this.getFlagList()
    await this.getRiderList()
    await this.getMerchantList()
    await this.getWalkingCustomerList()
    await this.getWaybillLayout()
    this.updateFilterCount()
  },

  methods: {
    async getWaybillLayout() {
      try {
        const { data } = (await LayoutRepository.getActiveWaybillLayout())
        this.layoutDropdownOptions = data.data
        this.layoutDropdownOptions.push(
          {
            id: 4,
            name: 'Default (V2)',
          },
          {
            id: 5,
            name: '10*10 (V2)',
          },
        )
      } catch (e) {
        this.showErrorMessage('Couldn\'t fetch waybill layout!')
      }
    },
    getProgressVariant(value) {
      if (value >= 0.00 && value <= 30.00) return 'danger'
      if (value >= 30.01 && value <= 64.00) return 'warning'
      if (value >= 64.01 && value <= 100) return 'success'
      return ''
    },
    getProgressBarClass(value) {
      if (value >= 0.00 && value <= 30.00) return 'progress-bar-danager'
      if (value >= 30.01 && value <= 64.00) return 'progress-bar-warning'
      if (value >= 64.01 && value <= 100) return 'progress-bar-success'
      return ''
    },
    async getOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = await orderRepository.getOrderList(this.page, filterQuery, this.perPage, (this.filters.rider ? 'sort=rider_sort_index' : ''))
        this.rows = data.data
        this.meta = data.meta
        if (this.page === 1) {
          this.allData = data.data
        } else {
          this.allData = [...this.allData, ...data.data]
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async getOrderListQueue() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await orderRepository.getOrderListQueue(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async getOrderSummary() {
      try {
        const summaryData = localStorage.getItem('all-orders-summery')
        const refreshDate = localStorage.getItem('all-orders-refresh-time')

        if (summaryData && refreshDate) {
          // Parse the JSON string back into a JavaScript object
          this.allOrdersSummery = JSON.parse(summaryData)
          this.refreshedDate = JSON.parse(refreshDate)
        } else {
          const { data } = (await orderRepository.getOrderSummery()).data
          this.allOrdersSummery = data
          this.refreshedDate = new Date()

          localStorage.setItem('all-orders-refresh-time', JSON.stringify(this.refreshedDate))
          // Convert the data to a JSON string and save it in local storage
          localStorage.setItem('all-orders-summery', JSON.stringify(this.allOrdersSummery))
        }
        this.orderOptions = this.allOrdersSummery
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getCityList() {
      try {
        this.cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityDropdownListNoFilter()).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.cityOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getFlagList() {
      this.flagOptions = localStorage.getItem('flag_list') ? JSON.parse(localStorage.getItem('flag_list')) : (await ResourceRepository.getFlagList()).data.data
      if (!localStorage.getItem('flag_list')) localStorage.setItem('flag_list', JSON.stringify(this.flagOptions))
    },
    async readOrderStatuses() {
      this.statusOptions = localStorage.getItem('active_order_statuses')
        ? JSON.parse(localStorage.getItem('active_order_statuses'))
        : (await orderRepository.getActiveStatusList()).data.data
      if (!localStorage.getItem('active_order_statuses')) {
        localStorage.setItem('active_order_statuses', JSON.stringify(this.statusOptions))
      }
    },
    async getRiderList() {
      this.riderOptions = localStorage.getItem('rider_list') ? JSON.parse(localStorage.getItem('rider_list')) : (await riderRepository.getAllRiderDropDown()).data.data
      if (!localStorage.getItem('rider_list')) localStorage.setItem('rider_list', JSON.stringify(this.riderOptions))
    },
    async getMerchantList() {
      this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await merchantRepository.getMerchantListForDropdown()).data.data
      if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
    },
    async fetchMerchantBusinesses(merchantIds) {
      try {
        if (!merchantIds || merchantIds.length === 0) {
          this.merchantBusinessOptions = []
          return
        }
        const businessPromises = merchantIds.map(merchantId => MerchantRepository.getMerchantBusinessListDropdown(merchantId))
        const results = await Promise.all(businessPromises)
        const allBusinesses = []
        const merchantMap = new Map()
        this.merchantOptions.forEach(merchant => {
          merchantMap.set(merchant.id, merchant.name)
        })

        results.forEach((result, index) => {
          const merchantId = merchantIds[index]
          const merchantName = merchantMap.get(merchantId) || 'Unknown Merchant'
          result.data.data.forEach(item => {
            const business = {
              ...item,
              display_name: `${item.business_name} (${merchantName})`,
            }
            allBusinesses.push(business)
          })
        })
        this.merchantBusinessOptions = allBusinesses
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getMerchantBusinessList() {
      try {
        this.loading = true
        if (!this.isApplyingSavedFilter) {
          this.selectedBusinessFilters = []
        }

        // Handle multiple merchant IDs
        if (!this.selectedMerchantFilters || this.selectedMerchantFilters.length === 0) {
          this.merchantBusinessOptions = []
          this.loading = false
          return
        }

        // Create a map of merchant ID to merchant name for easy lookup
        const merchantMap = new Map()
        this.merchantOptions.forEach(merchant => {
          merchantMap.set(merchant.id, merchant.name)
        })

        // Fetch businesses for all selected merchants
        const businessPromises = this.selectedMerchantFilters.map(merchantId => MerchantRepository.getMerchantBusinessListDropdown(merchantId))

        const results = await Promise.all(businessPromises)

        // Combine all businesses and remove duplicates, adding merchant name to each business
        const allBusinesses = []
        const businessIds = new Set()

        results.forEach((result, index) => {
          const merchantId = this.selectedMerchantFilters[index]
          const merchantName = merchantMap.get(merchantId) || 'Unknown Merchant'
          const businesses = result.data.data || []
          businesses.forEach(business => {
            if (!businessIds.has(business.id)) {
              businessIds.add(business.id)
              // Add merchant name to business object for display
              allBusinesses.push({
                ...business,
                merchant_name: merchantName,
                display_name: `${business.business_name} (${merchantName})`,
              })
            } else {
              // If duplicate business ID exists, update merchant name to show both merchants
              const existingBusiness = allBusinesses.find(b => b.id === business.id)
              if (existingBusiness && !existingBusiness.merchant_name.includes(merchantName)) {
                // Business exists under multiple merchants - update display to show both
                const existingMerchantName = existingBusiness.merchant_name
                existingBusiness.merchant_name = `${existingMerchantName}, ${merchantName}`
                existingBusiness.display_name = `${existingBusiness.business_name} (${existingBusiness.merchant_name})`
              }
            }
          })
        })

        this.merchantBusinessOptions = allBusinesses
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async getWalkingCustomerList() {
      this.walkingCustomers = localStorage.getItem('walking_customer_list') ? JSON.parse(localStorage.getItem('walking_customer_list')) : (await WalkingCustomerRepository.getWalkingCustomerDropdownList()).data.data
      if (!localStorage.getItem('walking_customer_list')) localStorage.setItem('walking_customer_list', JSON.stringify(this.walkingCustomers))
    },
    async getWarehouseList() {
      try {
        this.warehouseOptions = localStorage.getItem('warehouse_list') ? JSON.parse(localStorage.getItem('warehouse_list')) : (await ResourceRepository.getWarehouseListForDropDown()).data.data
        if (!localStorage.getItem('warehouse_list')) localStorage.setItem('warehouse_list', JSON.stringify(this.warehouseOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readOrderSetting() {
      try {
        this.orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(this.orderSettings))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchModules() {
      try {
        this.loading = true
        const data = localStorage.getItem('module_data') ? JSON.parse(localStorage.getItem('module_data')) : (await ResourceRepository.getModules()).data.data
        if (!localStorage.getItem('module_data')) localStorage.setItem('module_data', JSON.stringify(data))
        const aiSettingModule = data.find(module => module.name === 'AI Setting')
        this.aiModuleEnabled = aiSettingModule ? aiSettingModule.is_active : false
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async readAiSetting() {
      this.loading = true
      try {
        const data = localStorage.getItem('ai_setting') ? JSON.parse(localStorage.getItem('ai_setting')) : (await AiSettingRepository.getAiSetting()).data.data
        if (!localStorage.getItem('ai_setting')) localStorage.setItem('ai_setting', JSON.stringify(data))
        this.aiEnabled = data.enabled
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    isBulkUpdate(key) {
      const status = this.statusOptions.find(option => option.key === key)
      return status ? status.is_bulk_update : false
    },
    async updateRiderSortIndex(newIndex) {
      try {
        const payload = {
          rider_id: this.filters.rider,
          old_index: this.sortingOrder.rider_sort_index,
          new_index: this.rows[newIndex].rider_sort_index,
        }
        await orderRepository.updateRiderSortIndex(this.sortingOrder.id, payload)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onSummaryCardClick(key, selection) {
      this.selectedWaybillArray = []
      this.selectedStatusFilters = []
      this.selection = selection
      this.$nextTick(() => {
        this.applyFilters()
      })
      key.split(',').forEach(val => {
        if (val) this.selectedStatusFilters.push(val)
      })
    },
    onClickViewOrder(id) {
      this.$refs.viewOrderModal.openModal(id)
    },
    onClickEditOrder(id) {
      this.$refs.editOrderModal.openModal(id)
    },
    // onClickViewWeightHistory(id) { // TEMPORARILY COMMENTED OUT FOR RELEASE
    //   this.$refs.viewWeightHistoryModal.openModal(id)
    // },
    // Reusable function to check if order can be edited based on status
    canEditOrder(statusKey) {
      const editableStatusKeys = [
        'key_2', 'key_4', 'key_5', 'key_6', 'key_8', 'key_9', 'key_10',
        'key_11', 'key_12', 'key_15', 'key_16', 'key_17', 'key_18',
        'key_19', 'key_26', 'key_27', 'key_28', 'key_29',
      ]
      return editableStatusKeys.includes(statusKey)
    },
    onClickReverse(id) {
      this.$refs.reverseOrderModal.openModal(id)
    },
    onClickBulkFlagUpdate(id) {
      const selectedOrders = this.allData.filter(order => this.selectedWaybillArray.includes(order.waybill_number))
      // Extract the unique status keys from the selected orders
      const statusKeys = [...new Set(selectedOrders.map(order => order.order_current_status.key))].join(',')
      this.$refs.BulkFlagUpdate.openModal(id, statusKeys)
    },
    onClickSelectAll() {
      this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
    },
    onClickDeselctAll() {
      this.selectedWaybillArray = []
    },
    onClickPrintDispatch(id) {
      this.$router.push({
        name: 'print-pod',
        params: {
          waybillId: id,
          selectedWaybills: this.selectedWaybillArray,
        },
      })
    },
    setMonthFilter() {
      const currentMonth = this.monthFilter()
      this.updateDateRange('orders.created_at', currentMonth)
    },
    // REQUIRED
    applyFilters() {
      this.getOrderList()
      this.onClickDeselctAll()
      if (this.selectedStatusFilters.includes('key_17') || this.selectedStatusFilters.includes('key_18') || this.selectedStatusFilters.includes('key_19')) {
        this.filterFlagOptions()
      }
      this.updateFilterCount()
    },
    clearFilters() {
      this.selectedStatusFilters = []
      this.selectedFlagFilters = ''
      this.selectedBusinessFilters = ''
      this.selectedDestinationWarehouseFilters = ''
      this.selectedMerchantFilters = ''
      this.filters = {
        'orders.created_at': {
          startDate: null,
          endDate: null,
        },
        status_date: {
          startDate: null,
          endDate: null,
        },
      }
      this.merchantBusinessOptions = []
      this.$nextTick(() => {
        this.getOrderList()
      })
      this.updateFilterCount()
    },
    handlePaste() {
      setTimeout(() => {
        this.getOrderList()
      }, 0)
    },
    handleChangePage(page) {
      this.page = page
      this.getOrderList()
    },
    changePage(value) {
      this.perPage = value
    },
    onClickMakeRemark(id) {
      this.$refs.add_make_remark.openModal(id)
    },
    onClickViewFeedBack(id, url) {
      this.$refs.view_feedback.openModal(id, url)
    },
    onClickFlagDetail(wayBill, statusKey, id) {
      this.$refs.flag_detail.openModal(wayBill, statusKey, id)
    },
    onClickMakeFutureRequest(id) {
      this.$refs.add_future_request.openModal(id)
    },
    onClickBulkAction(key) {
      this.status_key = key
      this.$refs.bulkActionModal.openModal()
    },
    onChangeOriginPickupWarehouse() {
      this.formStructure = KeyFour.data().formStructure
      this.onClickBulkAction('key_4')
    },
    onAssignToPickupRider() {
      this.formStructure = KeyFive.data().formStructure
      this.onClickBulkAction('key_5')
    },
    onCancelClick() {
      this.formStructure = []
      this.onClickBulkAction('key_3')
    },
    onPickupFromMerchantClick() {
      this.formStructure = []
      this.onClickBulkAction('key_6')
    },
    onPickupDeliverClick() {
      this.formStructure = KeySeven.data().formStructure
      this.onClickBulkAction('key_7')
    },
    onDispatchClick() {
      this.formStructure = []
      this.onClickBulkAction('key_8')
    },
    onClickReceiveAtOriginWarehouse() {
      this.formStructure = KeyNine.data().formStructure
      this.onClickBulkAction('key_9')
    },
    onClickDispatchedToDestinationWarehouse() {
      this.formStructure = this.orderSettings.truck_driver_enabled ? KeyTen.data().formStructure : KeyTen.data().formStructure.splice(0, 3)
      this.onClickBulkAction('key_10')
    },
    onClickReceivedAtDestinationWarehouse() {
      this.formStructure = []
      this.onClickBulkAction('key_11')
    },
    onClickAssignedToDestinationRider() {
      this.formStructure = KeyTwelve.data().formStructure
      this.onClickBulkAction('key_12')
    },
    onClickDeliver() {
      this.formStructure = []
      this.onClickBulkAction('key_13')
    },
    onClickPartiallyDeliver() {
      this.formStructure = KeyFourteen.data().formStructure
      this.onClickBulkAction('key_14')
    },
    async onClickReturn() {
      const reasonOptions = await KeyFifteen.methods.formStructureForAllOrders()
      this.formStructure = KeyFifteen.data().formStructure
      this.formStructure[1].options = reasonOptions
      this.onClickBulkAction('key_15')
    },
    onClickReschedule() {
      this.formStructure = KeySixteen.data().formStructure
      this.onClickBulkAction('key_16')
    },
    async onClickDeliveryFailed() {
      const reasonOptions = await KeySeventeen.methods.formStructureForAllOrders()
      this.formStructure = KeySeventeen.data().formStructure
      this.formStructure[1].options = reasonOptions
      this.onClickBulkAction('key_17')
    },
    async onClickVerifyFailedToDeliver() {
      const reasonOptions = await KeyThirtySix.methods.formStructureForAllOrders()
      this.formStructure = KeyThirtySix.data().formStructure
      this.formStructure[1].options = reasonOptions
      this.onClickBulkAction('key_36')
    },
    onClickReturnedToSortingWarehouse() {
      this.formStructure = []
      this.onClickBulkAction('key_18')
    },
    onClickFailedReceiveToOriginWarehouse() {
      this.formStructure = []
      this.onClickBulkAction('key_19')
    },
    onClickReturnedToMerchant() {
      this.formStructure = []
      this.onClickBulkAction('key_20')
    },
    onClickReceiveFailedOrderWalkingCustomer() {
      this.formStructure = []
      this.onClickBulkAction('key_22')
    },
    onClickInvalidDestination() {
      this.formStructure = KeyTwentySix.data().formStructure
      this.onClickBulkAction('key_26')
    },
    onClickReturnedToSortingWarehouseInvalidDestination() {
      this.formStructure = []
      this.onClickBulkAction('key_27')
    },
    onClickReceivedToOriginWarehouseInvalidDestination() {
      this.formStructure = []
      this.onClickBulkAction('key_28')
    },
    onClickDifferentDestination() {
      this.formStructure = KeyTwentyEight.data().formStructure
      this.onClickBulkAction('key_29')
    },
    onClickReturnOrderReceivedAtOriginWarehouse() {
      this.formStructure = KeyReturnCommon.data().formStructure
      this.onClickBulkAction('key_24')
    },
    onClickAssignToReturnRider() {
      this.formStructure = KeyTwentyFive.data().formStructure
      this.onClickBulkAction('key_25')
    },
    onClickReceivedAtOriginWarehouse() {
      this.formStructure = KeyReturnCommon.data().formStructure
      this.onClickBulkAction('key_32')
    },
    onClickRescheduleReturn() {
      this.formStructure = KeyThirtyThree.data().formStructure
      this.onClickBulkAction('key_33')
    },
    onClickHandedOverToMerchant() {
      this.formStructure = KeyThirty.data().formStructure
      this.onClickBulkAction('key_30')
    },
    async onClickReturnToPickupWarehouse() {
      const reasonOptions = await KeyThirtyOne.methods.formStructureForAllOrders()
      this.formStructure = KeyThirtyOne.data().formStructure
      this.formStructure[1].options = reasonOptions
      this.onClickBulkAction('key_31')
    },
    onClickReturnOrderDispatchedToOriginWarehouse() {
      this.formStructure = []
      this.onClickBulkAction('key_23')
    },
    onClickReceivedToSortingWarehouse() {
      this.formStructure = []
      this.onClickBulkAction('key_35')
    },
    onClickDispatchedToSortingWarehouse() {
      this.formStructure = []
      this.onClickBulkAction('key_34')
    },
    onClickCustomStatus() {
      // Get the custom status key from the matching status
      const matchingStatus = this.statusOptions.find(
        status => this.selectedStatusFilters.includes(status.key)
          && status.after_statuses
          && Array.isArray(status.after_statuses)
          && status.after_statuses.some(afterStatus => afterStatus.startsWith('cus_'))
          && status.is_bulk_update === true,
      )

      if (matchingStatus && matchingStatus.after_statuses) {
        // Get the first custom status from the array
        const customStatus = matchingStatus.after_statuses.find(afterStatus => afterStatus.startsWith('cus_'))
        if (customStatus) {
          const statusObject = this.customStatusObject
          const statusActions = statusObject ? statusObject.actions : {}
          this.formStructure = KeyCustom.methods.staticFormStructure(statusActions)
          this.onClickBulkAction(customStatus)
        }
      }
    },
    // REQUIRED
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
        this.getOrderList()
      }
    },
    onClickReport() {
      this.$router.push({
        name: 'selected-report-download',
        params: {
          key: 'all-order',
        },
      })
    },
    onClickRefresh() {
      this.getOrderSummary()
      this.getOrderList()
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
      } else {
        this.selectedWaybillArray = []
      }
    },
    refreshAllOrderSummery() {
      this.loading = true
      localStorage.removeItem('all-orders-summery')
      localStorage.removeItem('all-orders-refresh-time')
      this.getOrderSummary().then(() => {
        this.loading = false
      })
    },
    async filterFlagOptions() {
      const { data } = (await flagRepository.getFlagDropdownByStatus(this.selectedStatusFilters))
      if (data.success) {
        this.flagOptions = data.data
        this.isStaffEnabled = this.flagOptions.some(option => option.is_staff_enable === true)
      } else {
        this.flagOptions = []
        this.isStaffEnabled = false
      }
    },
    hasActiveFilters() {
      // Check array selections
      if (this.selectedStatusFilters && this.selectedStatusFilters.length > 0) return true
      if (this.selectedFlagFilters && this.selectedFlagFilters.length > 0) return true
      if (this.selectedDestinationWarehouseFilters && this.selectedDestinationWarehouseFilters.length > 0) return true
      if (this.selectedMerchantFilters && this.selectedMerchantFilters.length > 0) return true
      if (this.selectedBusinessFilters && this.selectedBusinessFilters.length > 0) return true

      // Check date range filters
      const createdAt = this.filters['orders.created_at']
      if (createdAt && (createdAt.startDate || createdAt.endDate)) return true

      const statusDate = this.filters.status_date
      if (statusDate && (statusDate.startDate || statusDate.endDate)) return true

      // Check other properties in filters
      const ignoredKeys = ['orders.created_at', 'status_date', 'status', 'order_flag', 'merchant_business_id', 'destination_warehouse', 'merchant_id']
      return Object.keys(this.filters).some(key => {
        if (ignoredKeys.includes(key)) return false
        const value = this.filters[key]
        return value !== null && value !== undefined && String(value).trim() !== ''
      })
    },
    onSaveFilterClick() {
      if (!this.hasActiveFilters()) {
        this.showErrorMessage('At least one filter needs to be selected')
        return
      }
      this.$refs.saveFilterModal.show()
    },
    async saveFilter(name) {
      try {
        const payload = {
          name,
          screen: 'All Orders',
          filters: this.filters,
        }
        const response = await savedFilterRepository.save(payload)
        if (response.status === 200 || response.status === 201) {
          this.showSuccessMessage('Filter saved successfully')
          this.refreshSavedFilters()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onEditSavedFilter(filter) {
      this.$refs.editSavedFilterModal.openModal(filter)
    },
    async updateSavedFilter(payload) {
      try {
        const response = await savedFilterRepository.update(payload.id, payload)
        if (response.status === 200 || response.status === 201) {
          this.showSuccessMessage('Filter updated successfully')
          this.refreshSavedFilters()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    refreshSavedFilters() {
      // Find the SavedFiltersDropdown inside FilterButtons and call fetchSavedFilters
      // We can use a more reliable way if needed, but this is direct
      const { filterButtons } = this.$refs
      if (filterButtons) {
        const dropdown = filterButtons.$children.find(c => c.$options.name === 'SavedFiltersDropdown')
        if (dropdown && dropdown.fetchSavedFilters) {
          dropdown.fetchSavedFilters()
        }
      }
    },
    applySavedFilter(savedFilters) {
      this.isApplyingSavedFilter = true
      this.filters = { ...savedFilters }

      // Update UI components that are bound to separate arrays
      if (this.filters.status) {
        this.selectedStatusFilters = this.filters.status.split(',').filter(x => x)
      } else {
        this.selectedStatusFilters = []
      }

      if (this.filters.order_flag) {
        this.selectedFlagFilters = this.filters.order_flag.split(',').filter(x => x).map(Number)
      } else {
        this.selectedFlagFilters = []
      }

      if (this.filters.destination_warehouse) {
        this.selectedDestinationWarehouseFilters = this.filters.destination_warehouse.split(',').filter(x => x).map(Number)
      } else {
        this.selectedDestinationWarehouseFilters = []
      }

      if (this.filters.merchant_id) {
        this.selectedMerchantFilters = this.filters.merchant_id.split(',').filter(x => x).map(Number)
      } else {
        this.selectedMerchantFilters = []
      }

      if (this.filters.merchant_business_id) {
        this.selectedBusinessFilters = this.filters.merchant_business_id.split(',').filter(x => x).map(Number)
      } else {
        this.selectedBusinessFilters = []
      }

      this.$nextTick(() => {
        this.applyFilters()
        this.isApplyingSavedFilter = false
      })
    },
  },
}
</script>
<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';
.status-dropdown .vs__dropdown-menu {
  width: fit-content;
}
.vs__selected {
  position: relative !important;
  display: inline-flex !important;
  align-items: center;
  max-width: 180px !important;
  padding-right: 20px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.vs__selected > span {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: inline-block !important;
  max-width: 100% !important;
}
.vs__deselect {
  position: absolute !important;
  right: 4px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
.card-transaction {
  margin-bottom: 0 !important;
}
.refresh-button {
  float: right;
}
.refresh-icon {
  color: black !important;
}
.refresh-span {
  margin-bottom: 1px;
  color: black !important;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.timeAgo {
  margin-left: 5px;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.dropdown .dropdown-menu {
  max-height: 135px;
  overflow-y: auto;
}
#printDropdown .dropdown-menu {
  max-height: fit-content;
  overflow-y: auto;
}
.modal_size {
    width: 75% !important;
    margin: auto;
}
.custom-progress {
    width: 600px;
}
.left-name {
  font-weight: bolder;
  margin-left: 5px;
  margin-top: 3px;
  color: #666666;
}
.right-name {
  margin-left: 3px;
  margin-top: 3px;
  color: #666666;
}
.unable-pointer {
  pointer-events: none;
}
.all-orders-alert .alert {
  line-height: 30px;
}
@media (min-width: 1200px) {
  // .b-table thead tr th:last-child {
  //   position: sticky;
  //   right: 0;
  //   z-index: 0;
  // }
  #all-order-table tbody tr td:last-child {
    background-color: #f8f8f8;
  }
  #all-order-table thead tr th:nth-last-child(2) {
    position: sticky;
    right: 0px;
    z-index: 0;
  }
  #all-order-table tbody tr td:nth-last-child(2) {
    position: sticky;
    right: 0px;
    background-color: #f8f8f8;
    z-index: 0;
  }
}
@media (max-width: 767px) {
   .mr-mobile-half {
    margin-right: 0.125rem; /* half of mr-1 (0.25rem) */
  }
  #all-order-table thead th {
    position: sticky;
    top: 0;
  }
  .actionButtons {
    justify-content: end;
  }
  .status-dropdown .vs__dropdown-menu {
    width: 85vw;
  }
  .status-dropdown .vs__dropdown-option {
    white-space: normal;
  }
   .mr-mobile-half {
    margin-right: 0.125rem; /* half of mr-1 (0.25rem) */
  }
  .waybill-search .search-button {
    margin-top: 0 !important;
  }
}
.shadow-custom {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}
@media screen and (max-width: 412px) {
  .mr-mobile-half {
    margin-right: 0.25rem; /* half of mr-1 (0.25rem) */
  }
}
.key-client-crown {
  color: #d6a92c !important;
  fill: #d6a92c !important;
  svg {
    color: #d6a92c !important;
    fill: #d6a92c !important;
  }
}
</style>
